var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notifications-wrapper" },
    [
      _c(
        "transition-group",
        {
          staticClass: "notifications",
          attrs: { tag: "ul", name: "message-effect" },
          on: { "after-enter": _vm.afterEnter }
        },
        _vm._l(_vm.notifications, function(notification, index) {
          return _c(
            "li",
            {
              key: notification.id,
              staticClass: "message",
              class: _vm.messageClass(notification),
              attrs: { id: notification.id },
              on: {
                click: function($event) {
                  _vm.trackRemove(notification)
                }
              }
            },
            [
              _c("span", {
                staticClass: "message__icon",
                class: _vm.iconClass(notification)
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "message__text" },
                _vm._l(_vm.getLines(notification.message), function(line) {
                  return _c("p", { staticClass: "message__text__line" }, [
                    _vm._v(_vm._s(line))
                  ])
                })
              ),
              _vm._v(" "),
              _c("div", { staticClass: "message__close" }, [_vm._v("×")]),
              _vm._v(" "),
              _vm.hasTimeout(notification)
                ? _c("timer-vue", {
                    staticClass: "message__timer",
                    attrs: {
                      duration: _vm.getTimeout(notification),
                      running: notification._isTimerRunning
                    },
                    on: {
                      timeout: function($event) {
                        _vm.trackTimeout(notification)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }